<template>
  <div>
    <div class="flex-shrink-0">
        <apexchart class="apex-charts" dir="ltr" width="110px" height="110px" 
        :series='[$filters.getPercent(figure, total)]'
            :options="{ ...chartOptions }"></apexchart>
    </div>
  </div>
</template>

<script>

import VueApexCharts from "vue3-apexcharts";

export default {
    components:{
      apexchart: VueApexCharts,
    },
    props:{
        figure:{
            default: 0
        },
        chartColor: {
            default: "#0ab39c"
        },
        total:{
            default: 0
        },
    },
    data(){
        return {
            chartOptions: {
                chart: {
                    type: "radialBar",
                    width: 110,
                    sparkline: {
                        enabled: true,
                    }
                },
                dataLabels: {
                    enabled: false,
                },
                plotOptions: {
                    radialBar: {
                        hollow: {
                            margin: 0,
                            size: '55%'
                        },
                        track: {
                            margin: 1
                        },
                        dataLabels: {
                            show: true,
                            name: {
                                show: false
                            },
                            value: {
                                show: true,
                                fontSize: '16px',
                                fontWeight: 600,
                                color: '#fff',
                                offsetY: 5,
                            }
                        }
                    },
                },
                colors: [this.chartColor]
            }
        }
    }
}
</script>

<style scoped>

</style>